import { SET_PAGE_STATE, RESET_PAGE_STATE } from './actionTypes';

export const setPageState = ({ page, state }) => {
  const payload = { [page]: state };
  return {
    type: SET_PAGE_STATE,
    payload,
  };
};

export const resetPageState = (page) => ({
  type: RESET_PAGE_STATE,
  payload: page,
});
